import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSchool: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSchool"><Path fillRule="evenodd" clipRule="evenodd" d="M6 4H18V18H19V8H22V18H23V20H1V18H2V8H5V18H6V4ZM14 18V15H10V18H14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSchool;
